<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-7 col-xl-6">
                        <div class="font-weight-bold body-1">
                            Nueva Estimacion
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="7" xl="6">
                        <v-form ref="form" @submit.prevent="save">
                            <payment-form ref="IncomeConstructionPaymentForm" :values="form" @save="save" :serverErrors="serverErrors"></payment-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="7" xl="6" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import IncomeConstructionPaymentForm from "./Form.vue";
import Utils from '../../../helpers/Utils';
import Object2Form from '../../../helpers/Object2Form';
export default {
    components: {
        'payment-form': IncomeConstructionPaymentForm,
    },
	data(){
		return {
            construction: this.$route.params.construction,
            loading: false,
            serverErrors: {},
            form: {
                date:"", //fecha
                customer_id:"", //proveedor, no va al back. Se usa para obtener contractor_payable_account_id
                receivable_account_id:"", //obra
                payment_method_id:"", //forma de pago
                bank_account_id:"", //cuenta bancaria
                concept_id: "", //concepto
                folio: "",
                //factura
                pdf_file:[],
                pdf_file_url: "",

                xml_file:[],
                
                subtotal: 0,
                total: 0,
                discounts: 0,
                ieps:0,
                iva:0,
                isr_withholdings:0,
                iva_withholdings:0,
                currency:"MXN",
                uuid: "",
                exchange_rate_usd_mxn: 0, //tipo de cambio
                comments: "",


                cxp_list: []
                
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "IncomeConstructionPayments",
                block:false,	
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
    },
	methods: {
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;

			return this.$refs.form.validate();
            // return true;
		},
        save(){
            
            // console.log(this.form);
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                console.log(form);
                // return;
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.constructionPayment.store(this.$store.state.business, this.construction, form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha creado correctamente`);
                        this.$router.push({name: 'IncomeConstructionPayments'});
                    })
                    .catch((error) => {
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                
                                if(("error" in error.response.data)){
                                    if(error.response.data.error instanceof Object){
                                        Object.keys(error.response.data.error).forEach((x) => {
                                            
                                               
                                            console.log(x);
                                            this.serverErrors = error.response.data.error;
                                            error.response.data.error[x].forEach((y) => {
                                                this.serverErrors[x] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                    }else{
                                        errors.push(error.response.data.error)
                                    }
                                    
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }
                        console.log(this.serverErrors)
                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },
        prepareRequest(request)
        {
            let data = JSON.parse(JSON.stringify(request));
            data.pdf_file = request.pdf_file;
            data.xml_file = request.xml_file;
            // for (let i = 0; i < data.items.length; i++) {
            //     delete data.items[i].id;
            //     delete data.items[i].parameters;
            //     delete data.items[i].actions;
            // }

            return Object2Form.objectToFormData(data,'',[]);
        },
    },
}
</script>

<style>

</style>